import { SelectPicker } from "rsuite";
import './Layout.css';
import "../pages/Common.css";

interface Option {
    label: string;
    value: string | number;
}

const DropdownSearch = ({
    searchTxt,
    handleChange,
    placeholder,
    label,
    data,
    disabled = false,
    cleanable = true,
    searchable = true,
    loading = false,
    size = "md"
}: {
    searchTxt: string | number | null;
    handleChange: (value: string | number | null) => void;
    placeholder: string;
    label?: string;
    data: Option[];
    disabled?: boolean;
    cleanable?: boolean;
    searchable?: boolean;
    loading?: boolean;
    size?: "xs" | "sm" | "md" | "lg";
}) => (
    <div className="invite-input-wrapper">
        <label htmlFor="">{label}</label>
        {/* <div className="dropdown-search-wrapper"> */}
        <SelectPicker
            data={data}
            value={searchTxt}
            onChange={handleChange}
            placeholder={placeholder}
            searchable={searchable}
            cleanable={cleanable}
            disabled={disabled}
            loading={loading}
            size={size}
            style={{ width: '100%' }}
        />
    </div>
    // </div>
);


export default DropdownSearch;